import styled from 'styled-components';
import colors from '../../../../../assets/colors';

export const Content = styled.div`
  padding: 30px 30px 10px;
`;

export const ToggleContainer = styled.label`
  display: flex;
  width: 190px;
  height: 24px;
  margin-bottom: 30px;

  span {
    padding-top: 2px;
    padding-left: 15px;
    opacity: 1 !important;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 600;
    color: ${colors.primary};
    white-space: nowrap;
  }
`;
